// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_gM","advertCardFooter__row":"c-a_gN","advertCardFooter__name":"c-a_gO","advertCardFooter__price":"c-a_gP","advertCardFooter__age":"c-a_gQ"};